import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Config } from 'src/app/config/config';

@Component({
  selector: 'app-glens-select',
  templateUrl: './glens-select.component.html',
  styleUrls: ['./glens-select.component.scss']
})
export class GlensSelectComponent implements OnInit, OnChanges {


  @Input() form;
  @Input() settings;
  @Input() options;
  @Output() actions: EventEmitter<any>;

  public dropdownSettings:any;


  constructor() {
    this.actions = new EventEmitter();
  }

  public model = [];

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      text: this.settings.placeholder,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      badgeShowLimit: 4,
      primaryKey: this.settings.bindValue,
      labelKey: this.settings.bindLabel,
      enableCheckAll: this.settings.selectAll || false
    }
    this.dropdownSettings.disabled = this.settings.readonly ? true : false;
    this.onLoadFunctions();
  }
  ngOnChanges(changes: SimpleChanges) {
    try {
      this.onLoadFunctions();
    } catch (error) {
      console.log(error);
    }
  }
  onLoadFunctions() {
    try {
      this.model = [];
      this.mapOptions();
      this.mapModel();
    } catch (error) {
      Config.logger(error);
    }
  }
  changeDDValue(event) {
    this.form[this.settings.key] = this.model.map(ele => ele[this.settings.bindValue]);
    this.actions.emit(this.form[this.settings.key]);
  }
  mapOptions() {
    if (this.settings.options && this.settings.options.length > 0) {
      if (typeof (this.settings.options[0]) !== 'object') {
        this.settings.options = this.settings.options.map(ele => ({ key: ele, label: ele }));
        this.settings.bindValue = 'key';
        this.settings.bindLabel = 'label';
      }
    }
  }
  mapModel() {
    this.form[this.settings.key] = typeof this.form[this.settings.key] ===
      'string' ? [this.form[this.settings.key]] : this.form[this.settings.key];
    if (this.form[this.settings.key]) {
      const savedOptions = [];
      this.form[this.settings.key].forEach(element => {
        if (this.settings.options) {
          const index = this.settings.options.findIndex(ele => ele[this.settings.bindValue] === element);
          if (this.settings.options[index]) {
            const obj: any = {};
            obj[this.settings.bindValue] = element;
            obj[this.settings.bindLabel] = this.settings.options[index][this.settings.bindLabel];
            savedOptions.push(obj);
          }
        }
      });
      this.model = savedOptions;
    } else {
      // this.form[this.settings.key] = [];
      this.form[this.settings.key] = (this.settings.options && this.settings.options[0]) ? [this.settings.options[0].key] : [];
      this.model = (this.settings.options && this.settings.options[0]) ? [this.settings.options[0]] : [];
    }
  }

}
